// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3675fe35","867":"02c9249d"}[chunkId] + ".chunk.js";
};